import React from 'react';

import footer from '../../assets/images/footer.png';

const Footer = () => {

  return (
    <footer style={{
      height: 240,
      backgroundColor: '#14193A',
      width: '100%',
      padding: 60,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 120
    }}>
      <img
        src={footer}
        style={{
          height: '100%',
          width: 'auto'
        }}
        aria-label="CSIO, innovation through Standards"
      />
    </footer>
  )
}

export default Footer;
